/**
 * The event's speakers (GH-862), on the event page and the tickets page alike: the organizer's
 * order, a photo only where the organizer added one, the name, the role, and a short bio behind
 * an ⓘ (long copy lives behind the ⓘ, surface-inventory §8).
 *
 * No monogram stands in for a missing photo: initials are a name (ADDENDUM), and the name is
 * already the line beside it. A photo is the organizer's own, like the event cover — the one place
 * the donor surfaces carry representational imagery — so it gets the control radius, not a circle.
 */
import type { PublicLineupEntry } from "@givehere/contracts";
import { assetUrl } from "./api.js";
import { ExplainMore } from "./Explain.js";

export function Speakers({
  speakers,
  headingClassName,
}: {
  speakers: readonly PublicLineupEntry[];
  headingClassName?: string;
}) {
  if (speakers.length === 0) return null;
  return (
    <section className="speakers" aria-labelledby="speakers-title">
      <h2 id="speakers-title" className={headingClassName ?? "speakers__title"}>
        Speakers
      </h2>
      <ul className="speakers__list">
        {speakers.map((speaker, index) => {
          const role = [speaker.tagline, speaker.headliner ? "Headliner" : null]
            .filter(Boolean)
            .join(" · ");
          return (
            <li key={`${index}-${speaker.name}`} className="speakers__item">
              {speaker.photoUrl && (
                <img
                  className="speakers__photo"
                  src={assetUrl(speaker.photoUrl)}
                  alt=""
                  width={56}
                  height={56}
                  loading="lazy"
                />
              )}
              <span className="speakers__text">
                <span className="speakers__name" dir="auto">
                  {speaker.name}
                </span>
                {role && (
                  <span className="speakers__role" dir="auto">
                    {role}
                  </span>
                )}
              </span>
              {speaker.description && (
                <ExplainMore title={`About ${speaker.name}`}>
                  <p dir="auto">{speaker.description}</p>
                </ExplainMore>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
